import i18next, { FormatterModule } from "i18next";

import { formatPlain } from "../utilities/format/number";

// Note: i18next binds its own formatter at init and does not export it, so the built-in one is taken from a
// scratch instance and handed every named format ({{hours, list}}); only a bare number is ours.
const scratch = i18next.createInstance();
scratch.init({ initAsync: false });
const builtIn = scratch.services.formatter!;

export const numberFormatter: FormatterModule = {
  type: "formatter",
  init: (services, options) => builtIn.init(services, options),
  add: (name, fc) => builtIn.add(name, fc),
  addCached: (name, fc) => builtIn.addCached(name, fc),
  format: (value, format, lng, options) =>
    !format && typeof value === "number" ? formatPlain(value) : builtIn.format(value, format, lng, options),
};
